export const CREATE_BANK_ROUTING_CODE = "CREATE_BANK_ROUTING_CODE";
export const FETCH_BANK_ROUTING_CODES = "FETCH_BANK_ROUTING_CODES";
export const FETCH_BANK_ROUTING_CODE = "FETCH_BANK_ROUTING_CODE";
export const EDIT_BANK_ROUTING_CODE = "EDIT_BANK_ROUTING_CODE";
export const DELETE_BANK_ROUTING_CODE = "DELETE_BANK_ROUTING_CODE";
